import React from 'react';
import './MenuButton.css';

const MenuButton = (props: any) => {
	const onChangeValueKeyboard = (e: any) => {
		if (e.keyCode == 32 || e.keyCode == 13 && props.onClick) { //32 - spacebar, 36 - enter
			props.onClick();
		}
	};
	return (
		<div className="button-background modal-disable-select" title={props.text}
			tabIndex={0}
			aria-label={props.text + (props.disabled ? " locked" : " unlocked")}
			role={(props.disabled ? "" : "button")}
			onClick={props.onClick}
			onKeyDown={onChangeValueKeyboard}>
			<div style={{
				height: '100%',
				backgroundImage: props.disabled ? 'url(assets/img/lock.png)' : ''
			}} className={`menu-btn ${props.disabled ? 'disabled-btn' : ''} ${props.completed ? 'completed-btn' : ''} ${props.color}`}
			onClick={props.onClick}>
				<p style={{
					margin: '0',
					position: 'relative',
					top: '50%',
					transform: 'translate(0, -50%)'
				}}>{props.text}</p>
			</div>
		</div>
	);
};

export default MenuButton;
